import { useLingui } from '@lingui/react/macro';

import Close from '@rover/icons/svg/close.svg';
import { Box, Button, Flex } from '@rover/kibble/core';
import useTheme from '@rover/kibble/themes/useTheme';

type ImageGridCloseButtonProps = {
  onClick: () => void;
  /**
   * The button sits over the photos instead of in a header row: give it a
   * dark circular backdrop so the glyph reads against any tile behind it, and
   * drop the header-row right-alignment (the floating slot pins it already).
   */
  floating?: boolean;
};

const ImageGridCloseButton = ({
  onClick,
  floating = false,
}: ImageGridCloseButtonProps): JSX.Element => {
  const { t } = useLingui();
  const { colors } = useTheme();
  const button = (
    <Button
      variant="flat"
      icon={Close}
      onClick={onClick}
      aria-label={t`Dismiss`}
      sx={{
        color: colors.text.primary_inverse,
        '&:hover, &:focus': { color: colors.interactive_link.secondary_inverse_pressed },
      }}
      circular
      contrast
    />
  );
  if (floating) {
    return (
      <Box background="overlay" borderRadius="round">
        {button}
      </Box>
    );
  }
  return (
    <Flex justifyContent="flex-end" flexDirection="row">
      {button}
    </Flex>
  );
};

export default ImageGridCloseButton;
